.picker {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--tuna-spacing-2);
  width: 100%;
}

.card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--tuna-spacing-1);
  padding: var(--tuna-spacing-2);
  min-height: 96px;
}

.cardTitle {
  font-size: var(--tuna-typography-body-fontSize);
  font-weight: 600;
}

.cardBody {
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-content-secondary);
  text-align: left;
}

@media (max-width: 600px) {
  .picker {
    grid-template-columns: 1fr;
  }
}
